@let f = form();
<div class="pt-16">
    <div class="grid grid-cols-1 gap-x-[50px] gap-y-16 lg:grid-cols-2">
        <div class="lg:col-span-2">
            <ui-input-textarea
                [formControl]="f.controls.message"
                [defaultHeight]="110"
                [error]="form().controls.message.touched && form().controls.message.invalid"
                [errorMsg]="getErrorMessage(f.controls.message, errorMsg())"
                (click)="trackingStart()"
                label="Ihre Nachricht"
                placeholder="Schreiben Sie etwas..."
            />
        </div>
    </div>

    <lib-distribution-contact-template
        [form]="f"
        [errorMsg]="errorMsg()"
        (formClicked)="trackingStart()"
        (submitClicked)="submitClicked.emit()"
    />
</div>
